import { render, staticRenderFns } from "./industryNorms.vue?vue&type=template&id=497d7e8a&scoped=true"
import script from "./industryNorms.vue?vue&type=script&lang=js"
export * from "./industryNorms.vue?vue&type=script&lang=js"
import style0 from "./industryNorms.vue?vue&type=style&index=0&id=497d7e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497d7e8a",
  null
  
)

export default component.exports